import { useState } from "react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions, DialogTitle } from "@mui/material";
import { styled } from '@mui/material/styles';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const UploadImages: React.FunctionComponent<{ errors: any, OnUploadImages: any, image: any, listImages: any[], multipleImgs: boolean, height: any, label: string }> = (props) => {

    const [isHovered, setIsHovered] = useState(false);
    const [isOpenPhotosListing, setIsOpenPhotosListing] = useState(false);
    const [imageSelected, setImageSelected] = useState<any>(null);

    function getRandomSixDigitNumber(): number {
        return Math.floor(100000 + Math.random() * 900000);
    }

    // Compress and resize image for PDF compatibility
    const compressImage = (file: File, maxWidth: number = 1200, quality: number = 0.8): Promise<string> => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                const img = new window.Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;

                    // Resize if larger than maxWidth
                    if (width > maxWidth) {
                        height = (height * maxWidth) / width;
                        width = maxWidth;
                    }

                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    if (ctx) {
                        ctx.drawImage(img, 0, 0, width, height);
                        // Convert to JPEG for better compression and PDF compatibility
                        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
                        resolve(compressedBase64);
                    } else {
                        resolve(e.target?.result as string);
                    }
                };
                img.onerror = () => {
                    resolve(e.target?.result as string);
                };
                img.src = e.target?.result as string;
            };
        });
    };

    const handleSelectSingleImage = (image: any) => {
        // Sélectionner une seule image avec objet contenant src, id et ext
        const selectedImageObj = {
            id: image.id,
            src: image.src,
            ext: image.ext
        };
        setImageSelected(selectedImageObj);
    };

    const HandleChangeUpload = async (event: any) => {
        const files = event.target.files;
        const updatedImages: any[] = [];
        setIsOpenPhotosListing(false);
        
        const fileProcessors = Array.from(files).map(async (file: any) => {
            // Compress the image for PDF compatibility
            const compressedBase64 = await compressImage(file);
            const image = {
                id: getRandomSixDigitNumber(),
                src: compressedBase64,
                ext: 'jpeg', // Always JPEG after compression
            };
            updatedImages.push(image);
        });

        await Promise.all(fileProcessors);
        props.OnUploadImages(updatedImages);
    }


    return (
        <>
            {props.image ?
                <div className={`read-photo  ${props.height}`} onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    {props.image &&
                        <img src={props.image} className={`previewImage`} id={`previewImage-1`} />
                    }
                    {(props.multipleImgs === false && isHovered &&
                        <button className="hover-button" onClick={() => {
                            setIsOpenPhotosListing(true);
                        }}>
                            <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.1618 8.99499L12.8335 6.31166V17.5C12.8335 17.8094 12.9564 18.1062 13.1752 18.3249C13.394 18.5437 13.6907 18.6667 14.0002 18.6667C14.3096 18.6667 14.6063 18.5437 14.8251 18.3249C15.0439 18.1062 15.1668 17.8094 15.1668 17.5V6.31166L17.8385 8.99499C17.947 9.10434 18.076 9.19113 18.2182 9.25036C18.3603 9.30959 18.5128 9.34009 18.6668 9.34009C18.8208 9.34009 18.9733 9.30959 19.1155 9.25036C19.2577 9.19113 19.3867 9.10434 19.4952 8.99499C19.6045 8.88653 19.6913 8.7575 19.7505 8.61533C19.8098 8.47316 19.8403 8.32067 19.8403 8.16666C19.8403 8.01264 19.8098 7.86015 19.7505 7.71798C19.6913 7.57582 19.6045 7.44678 19.4952 7.33832L14.8285 2.67166C14.7175 2.56544 14.5867 2.48218 14.4435 2.42666C14.1595 2.30997 13.8409 2.30997 13.5568 2.42666C13.4136 2.48218 13.2828 2.56544 13.1718 2.67166L8.50516 7.33832C8.39638 7.4471 8.3101 7.57624 8.25123 7.71837C8.19236 7.86049 8.16206 8.01282 8.16206 8.16666C8.16206 8.32049 8.19236 8.47282 8.25123 8.61495C8.3101 8.75707 8.39638 8.88621 8.50516 8.99499C8.61394 9.10377 8.74308 9.19006 8.88521 9.24893C9.02733 9.3078 9.17966 9.3381 9.3335 9.3381C9.48733 9.3381 9.63966 9.3078 9.78179 9.24893C9.92391 9.19006 10.0531 9.10377 10.1618 8.99499ZM24.5002 16.3333C24.1907 16.3333 23.894 16.4562 23.6752 16.675C23.4564 16.8938 23.3335 17.1906 23.3335 17.5V22.1667C23.3335 22.4761 23.2106 22.7728 22.9918 22.9916C22.773 23.2104 22.4762 23.3333 22.1668 23.3333H5.8335C5.52408 23.3333 5.22733 23.2104 5.00854 22.9916C4.78975 22.7728 4.66683 22.4761 4.66683 22.1667V17.5C4.66683 17.1906 4.54391 16.8938 4.32512 16.675C4.10633 16.4562 3.80958 16.3333 3.50016 16.3333C3.19074 16.3333 2.894 16.4562 2.6752 16.675C2.45641 16.8938 2.3335 17.1906 2.3335 17.5V22.1667C2.3335 23.0949 2.70225 23.9852 3.35862 24.6415C4.015 25.2979 4.90524 25.6667 5.8335 25.6667H22.1668C23.0951 25.6667 23.9853 25.2979 24.6417 24.6415C25.2981 23.9852 25.6668 23.0949 25.6668 22.1667V17.5C25.6668 17.1906 25.5439 16.8938 25.3251 16.675C25.1063 16.4562 24.8096 16.3333 24.5002 16.3333Z" fill="#f8f9fd" />
                            </svg>
                            <p className="mt-2 title-onest-18 bold-600 color-FFFFFF mb-0"> {props.label}</p>
                        </button>
                    )}
                </div>
                :
                <div className="upload-xml w-100 max-width-870">
                    <label className={`form__container  ${props.errors ? 'input-error' : ''} ${props.height}`} id="upload-container">
                        <svg width="106" height="105" viewBox="0 0 106 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="53.3633" cy="52.7886" r="51.745" fill="white" />
                            <g clipPath="url(#clip0_1923_4509)">
                                <path d="M44.7185 37.3298L43.8777 39.8524H37.8381C34.984 39.8524 32.6636 42.1728 32.6636 45.0269V65.7248C32.6636 68.5789 34.984 70.8993 37.8381 70.8993H68.8851C71.7391 70.8993 74.0596 68.5789 74.0596 65.7248V45.0269C74.0596 42.1728 71.7391 39.8524 68.8851 39.8524H62.8454L62.0046 37.3298C61.4791 35.7451 59.9995 34.6779 58.3258 34.6779H48.3973C46.7237 34.6779 45.2441 35.7451 44.7185 37.3298ZM53.3616 63.1376C49.0764 63.1376 45.5998 59.661 45.5998 55.3759C45.5998 51.0907 49.0764 47.6141 53.3616 47.6141C57.6467 47.6141 61.1233 51.0907 61.1233 55.3759C61.1233 59.661 57.6467 63.1376 53.3616 63.1376Z" fill="#7C3AED" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1923_4509">
                                    <rect width="41.396" height="41.396" fill="white" transform="translate(32.6634 32.0906)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <p className="mt-2 title-onest-24 bold-600 color-9868F2 mb-0">{props.label}</p>

                        <input className="form__file" id="upload-files" onClick={() => {
                            setIsOpenPhotosListing(true);
                        }} />
                    </label>
                    <div id="files-list-container"></div>
                </div>
            }

            <BootstrapDialog
                open={isOpenPhotosListing}
                onClose={() => setIsOpenPhotosListing(false)}
                aria-labelledby="customized-dialog-title"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle >
                    <div className="title-24">Select Photos in Listing</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpenPhotosListing(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="d-flex justify-content-end mb-4">
                        <button
                            className="button-dash back-746AFF color-4F52C1 border-trans padd-10"
                        >
                            <label style={{ cursor: 'pointer', margin: 0 }}>
                                <p className="title-onest-18 bold-600 color-FFFFFF" style={{ margin: 0 }}>Upload photos from desktop</p>
                                <input className="form__file" id="upload-files-dialog" accept="image/*" type="file" multiple={false} onChange={HandleChangeUpload} hidden />
                            </label>
                        </button>
                    </div>
                    {props.listImages == null ? (
                        <div></div>
                    ) : (
                        <div className="image-grid">
                            {props.listImages.map((image: any, index: number) => {
                                const isSelected = imageSelected?.id === image.id;
                                return (
                                    <div
                                        key={image.id + "_" + index}
                                        className="select-image-container"
                                        onClick={() => handleSelectSingleImage(image)}
                                        style={{
                                            cursor: "pointer",
                                            border: isSelected ? "3px solid #4F52C1" : "1px solid #ddd",
                                            borderRadius: "8px",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id={image.id + "_" + index}
                                            name="singleImageSelect"
                                            value={image.src}
                                            checked={isSelected}
                                            onChange={() => handleSelectSingleImage(image)}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        <img
                                            src={image.src}
                                            className="image"
                                            alt={`uploaded-${index}`}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    )}

                </DialogContent>
                <DialogActions>
                    <div className="d-flex justify-content-end w-100 padd-10">
                        <button
                            type="button"
                            className={`button-dash back-done color-4F52C1 back-trans padd-20 ${imageSelected == null ? 'disabled' : ''}`}
                            onClick={() => {
                                if (imageSelected) {
                                    props.OnUploadImages([imageSelected]);
                                    setIsOpenPhotosListing(false);
                                    setImageSelected(null);
                                }
                            }}
                        >
                            Change photo
                        </button>
                    </div>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}

export default UploadImages;